import { JoinClassName } from '../utils/cssHelper';
import CSSStyle from './index.module.css';
import React, { useState, useCallback, PropsWithChildren, useEffect, useRef, useContext } from "react";
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { Stripe, StripeCardElement, StripeCardElementChangeEvent, StripeCardElementOptions, PaymentMethod } from '@stripe/stripe-js';
import { FormattedMessage } from 'react-intl';
import { AssetsContext, StripeAssetsContext, PaymentRequestInfo } from '../model';


export type StripeCreditCardEntryProps = {
    onCreditCardReady: (cardPaymentMethod: PaymentMethod) => void;
    onCancelNewCreditCard: () => void;
    shown: boolean;
    paymentRequestInfo: PaymentRequestInfo;
    onShowLoading: () => void;
    onCloseLoading: () => void;
}
export default function StripeCreditCardEntry(props: StripeCreditCardEntryProps) {
    const appContext: AssetsContext = useContext(StripeAssetsContext);
    const stripe = useStripe();
    const elements = useElements();
    const cardElementReadyTimeRef = useRef<any>(null);
    const mainBackgroundStyle = !appContext.assetsSetting.addNewCreditCardBackground ? {} : {
        backgroundImage: `url(${appContext.assetsSetting.addNewCreditCardBackground})`
    }

    // console.log('cardNewBackgroundImage', loadAsset(cardNewBackgroundImage))

    const CARD_OPTIONS: StripeCardElementOptions = {
        iconStyle: 'solid',
        hidePostalCode: true,
    };
    const [error, setError] = useState<any>(null);
    let _onNewCreditCardEnterChange_ = useCallback((e: StripeCardElementChangeEvent) => {
        if (!e.error && e.complete) {
            setError(null);
        } else {
            setError(e.error);
        }

    }, []);

    let _onCardElementReady_ = useCallback(() => {
        cardElementReadyTimeRef.current && clearTimeout(cardElementReadyTimeRef.current);
        props.onCloseLoading();
        // eslint-disable-next-line 
    }, [props]);


    let _onCreditCardReady_ = useCallback(async () => {
        if (!elements || !stripe) {
            return;
        }
        props.onShowLoading();
        const cardElement = elements.getElement(CardElement) as StripeCardElement;
        const { error: createPaymentMethodError, paymentMethod } = await (stripe as Stripe).createPaymentMethod({
            type: 'card',
            card: cardElement,
            metadata: {
                ...props.paymentRequestInfo.metaData || {}
            },
        });
        props.onCloseLoading();
        if (createPaymentMethodError) {
            setError(createPaymentMethodError);
        } else {
            props.onCreditCardReady(paymentMethod as PaymentMethod);
        }

        // eslint-disable-next-line
    }, [props, elements, stripe])


    useEffect(() => {
        cardElementReadyTimeRef.current = setTimeout(() => {
            props.onShowLoading();
        }, 1000);

        return () => {
            cardElementReadyTimeRef.current && clearTimeout(cardElementReadyTimeRef.current);
            props.onCloseLoading();
        }
        // eslint-disable-next-line 
    }, []);
    const ErrorMessage = (props: PropsWithChildren<{}>) => (
        <div className={JoinClassName(CSSStyle.errorMessage)} role="alert">
            <svg width="16" height="16" viewBox="0 0 17 17">
                <path
                    fill="#FFF"
                    d="M8.5,17 C3.80557963,17 0,13.1944204 0,8.5 C0,3.80557963 3.80557963,0 8.5,0 C13.1944204,0 17,3.80557963 17,8.5 C17,13.1944204 13.1944204,17 8.5,17 Z"
                />
                <path
                    fill="#6772e5"
                    d="M8.5,7.29791847 L6.12604076,4.92395924 C5.79409512,4.59201359 5.25590488,4.59201359 4.92395924,4.92395924 C4.59201359,5.25590488 4.59201359,5.79409512 4.92395924,6.12604076 L7.29791847,8.5 L4.92395924,10.8739592 C4.59201359,11.2059049 4.59201359,11.7440951 4.92395924,12.0760408 C5.25590488,12.4079864 5.79409512,12.4079864 6.12604076,12.0760408 L8.5,9.70208153 L10.8739592,12.0760408 C11.2059049,12.4079864 11.7440951,12.4079864 12.0760408,12.0760408 C12.4079864,11.7440951 12.4079864,11.2059049 12.0760408,10.8739592 L9.70208153,8.5 L12.0760408,6.12604076 C12.4079864,5.79409512 12.4079864,5.25590488 12.0760408,4.92395924 C11.7440951,4.59201359 11.2059049,4.59201359 10.8739592,4.92395924 L8.5,7.29791847 L8.5,7.29791847 Z"
                />
            </svg>
            {props.children}
        </div>
    );

    return (
        <div className={JoinClassName(CSSStyle.add_new_credit_card_conatiner)} style={{ display: props.shown ? 'flex' : 'none' }}>
            <div className={JoinClassName(CSSStyle.top)}>
                <div className={JoinClassName(CSSStyle.left)} onClick={props.onCancelNewCreditCard}><FormattedMessage id="cancel_button"></FormattedMessage></div>
                <div className={JoinClassName(CSSStyle.middle)}><FormattedMessage id="add_new_card"></FormattedMessage></div>
                <div className={JoinClassName(CSSStyle.right, error ? '' : CSSStyle.done)} onClick={_onCreditCardReady_}>
                    <FormattedMessage id="done_button"></FormattedMessage>
                </div>
            </div>
            {error && <ErrorMessage>{error.message}</ErrorMessage>}
            <div className={JoinClassName(CSSStyle.main)}>
                <div className={JoinClassName(CSSStyle.main_bk)} style={mainBackgroundStyle} ></div>
                <CardElement onReady={_onCardElementReady_} className={JoinClassName(CSSStyle.create_ard_entry)} options={CARD_OPTIONS} onChange={_onNewCreditCardEnterChange_} />
            </div>
        </div>
    );
}